import React, { useContext, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Sidebar from './Sidebar';

const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login'); // Redirect to login if no user is logged in
    }
  }, [user, navigate]);

  if (!user) {
    return null; // Don't render anything while redirecting
  }

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar — handles both desktop (static) and mobile (slide-in panel) */}
      <div className="hidden md:block flex-shrink-0">
        <Sidebar />
      </div>
      <div className="md:hidden">
        <Sidebar />
      </div>

      {/* Main content area — offset on mobile to clear the sticky header (≈56px) */}
      <div className="flex-1 bg-[#f4f4fa] overflow-auto mt-[56px] md:mt-0">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
